<pbc-filter [config]="StandortsFilterConfig" [filter]="standorts.filter$ | async" (filterChange)="standorts.filter$.next($event)"></pbc-filter>
